
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    // export class PsDiscCouponTypeItemExtDialog extends Serenity.EntityDialog<PsDiscCouponTypeItemExtRow, any> {
        export class PsDiscCouponTypeItemExtDialog extends Serenity.Extensions.GridEditorDialog<PsDiscCouponTypeItemExtRow> {
        protected getFormKey() { return PsDiscCouponTypeItemExtForm.formKey; }
        // protected getIdProperty() { return PsDiscCouponTypeItemExtRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeItemExtRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeItemExtRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeItemExtService.baseUrl; }
        // protected getDeletePermission() { return PsDiscCouponTypeItemExtRow.deletePermission; }
        // protected getInsertPermission() { return PsDiscCouponTypeItemExtRow.insertPermission; }
        // protected getUpdatePermission() { return PsDiscCouponTypeItemExtRow.updatePermission; }

        protected form = new PsDiscCouponTypeItemExtForm(this.idPrefix);

        private pass: string

        public get Pass(): string { return this.pass }
        set Pass(value: string) { this.pass = value; }

        protected afterLoadEntity() {
            super.afterLoadEntity();
               
            if (this.isNew()) {
                this.form.DiscCouponType.value = this.pass                
            }
            
        }

    }
}